import { BalancerSDK } from '@balancer-labs/sdk';
// Type-only import (erased at build, no bundle impact) used solely to bridge
// the app's Network enum — a superset of the SDK's — to the SDK's own type.
// eslint-disable-next-line no-restricted-imports
import type { Network as SdkNetwork } from '@balancer-labs/sdk';
import { Network } from '@/lib/config/types';
import { configService } from '@/services/config/config.service';
import { ref } from 'vue';
// import { isTestMode } from '@/plugins/modes';

// The Balancer SDK only ships config for the chains it officially supports.
// This app can run on chains the SDK doesn't know (e.g. Arbitrum Sepolia,
// 421614), and the SDK constructor throws when it can't resolve the network's
// config ("Cannot read properties of undefined (reading 'urls')"). The custom
// RiskProtocol pool flow doesn't use the SDK, so if instantiation fails we fall
// back to a supported network purely so the module can load without crashing.
function createBalancerSDK(): BalancerSDK {
  const sdkConfig = {
    // The app's Network enum is a superset of the SDK's, so bridge the type.
    network: configService.network.chainId as unknown as SdkNetwork,
    rpcUrl: configService.rpc,
    customSubgraphUrl: configService.network.subgraph,
  };
  try {
    return new BalancerSDK(sdkConfig);
  } catch {
    return new BalancerSDK({
      ...sdkConfig,
      network: Network.MAINNET as unknown as SdkNetwork,
    });
  }
}

export const balancer = createBalancerSDK();

export const hasFetchedPoolsForSor = ref(false);

export async function fetchPoolsForSor() {
  if (hasFetchedPoolsForSor.value) return;

  console.time('fetchPoolsForSor');
  await balancer.swaps.fetchPools();
  hasFetchedPoolsForSor.value = true;
  console.timeEnd('fetchPoolsForSor');
}

// if (!isTestMode()) fetchPoolsForSor();
